import { LOCATION_SEARCH_TYPE } from '@/types'

export type LocationSearchTypeWithNearbyAirports = LOCATION_SEARCH_TYPE & {
  nearbyAirports: LOCATION_SEARCH_TYPE[]
}

export function processLocationSearchData(
  matchedRegions: LocationSearchTypeWithNearbyAirports[]
) {
  if (matchedRegions.length === 0) {
    return []
  }
  let hasCityOnly = true
  const result = matchedRegions.reduce<
    Array<LocationSearchTypeWithNearbyAirports | LOCATION_SEARCH_TYPE>
  >((computedResult, current) => {
    if (current.type === 'AIRPORT') {
      hasCityOnly = false
      computedResult.push(current)
    }
    if (
      (current.type === 'HOTEL_CITY' || current.type === 'CITY') &&
      current.nearbyAirports.length >= 1
    ) {
      computedResult.push({
        ...current.nearbyAirports[0],
        cityName: current.displayName
      })
    }
    return computedResult
  }, [])
  return hasCityOnly
    ? matchedRegions[0].nearbyAirports.map(item => ({
        ...item,
        cityName: matchedRegions[0].displayName,
        nearbyAirports: matchedRegions[0].nearbyAirports
      }))
    : result
}
